import React, { useState, useEffect } from 'react';
import {
  DataSearch,
  MultiList,
  ReactiveBase,
  ReactiveComponent,
  ReactiveList,
  StateProvider,
} from '@appbaseio/reactivesearch';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { CheckboxList } from '../../components/elasticsearch/CheckboxList';

import reactivesearchTheme from '../../reactivesearchTheme';

import './exhibitors-catalog.css';

const sortOptions = [
  {
    label: 'Best Match',
    sortBy: [{ _score: { order: 'desc' } }, { 'shortName.keyword': { order: 'asc' } }],
  },
  {
    label: 'A-Z',
    sortBy: [{ 'shortName.keyword': { order: 'asc' } }],
  },
  {
    label: 'Z-A',
    sortBy: [{ 'shortName.keyword': { order: 'desc' } }],
  },
];

const newTypography = { ...reactivesearchTheme.typography, ...{ fontSize: 'inherit' } };
const newReactivesearchTheme = { ...reactivesearchTheme, ...{ typography: newTypography } };

function ExhibitorsCatalog({
  url,
  credentials,
  app,
  fair,
  defaultValue,
  type,
}) {
  const [sort, setSort] = useState(sortOptions[0]);

  useEffect(() => {
    window.initCustomForms();
    window.initMobileNavFilters();
  }, []);

  return (
    <ReactiveBase
      url={url}
      credentials={credentials}
      app={app}
      enableAppbase
      theme={newReactivesearchTheme}
      defaultValue={defaultValue}
    >
      <div className="filters-section pt-0">
        <div className="container">
          <div className="filters-section-inner ajax-filters-container-paginated">
            <div className="filter-box">
              <fieldset>
                <div className="filter-section-holder">
                  <hr />
                  <div className="filters-wrap filters-wrap--filters init-pinned" id="filters-wrap--exhibitors">
                    <div className="filters-inner-holder d-flex flex-wrap align-items-center">
                      <div className="search-filter w-100 w-lg-auto mb-3 mb-lg-0 ms-lg-5 order-lg-1">
                        <DataSearch
                          innerClass={{
                            input: 'form-control',
                            list: 'gallery-title__list',
                          }}
                          componentId="q"
                          dataField={[
                            'title',
                          ]}
                          iconPosition="right"
                          filterLabel="Search term"
                          placeholder="Search for exhibitors"
                          react={{ and: ['type', 'location', 'fair', 'fairSection'] }}
                          URLParams
                          // searchOperators
                          fuzziness="AUTO"
                        />
                      </div>
                      <button type="button" className="filters-main-opener filters-btn text-uppercase p-0 px-2 px-lg-0 me-3 w-auto order-lg-0">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                          <path d="M0 416C0 407.2 7.164 400 16 400H81.6C89.01 363.5 121.3 336 160 336C198.7 336 230.1 363.5 238.4 400H496C504.8 400 512 407.2 512 416C512 424.8 504.8 432 496 432H238.4C230.1 468.5 198.7 496 160 496C121.3 496 89.01 468.5 81.6 432H16C7.164 432 0 424.8 0 416V416zM208 416C208 389.5 186.5 368 160 368C133.5 368 112 389.5 112 416C112 442.5 133.5 464 160 464C186.5 464 208 442.5 208 416zM352 176C390.7 176 422.1 203.5 430.4 240H496C504.8 240 512 247.2 512 256C512 264.8 504.8 272 496 272H430.4C422.1 308.5 390.7 336 352 336C313.3 336 281 308.5 273.6 272H16C7.164 272 0 264.8 0 256C0 247.2 7.164 240 16 240H273.6C281 203.5 313.3 176 352 176zM400 256C400 229.5 378.5 208 352 208C325.5 208 304 229.5 304 256C304 282.5 325.5 304 352 304C378.5 304 400 282.5 400 256zM496 80C504.8 80 512 87.16 512 96C512 104.8 504.8 112 496 112H270.4C262.1 148.5 230.7 176 192 176C153.3 176 121 148.5 113.6 112H16C7.164 112 0 104.8 0 96C0 87.16 7.164 80 16 80H113.6C121 43.48 153.3 16 192 16C230.7 16 262.1 43.48 270.4 80H496zM144 96C144 122.5 165.5 144 192 144C218.5 144 240 122.5 240 96C240 69.49 218.5 48 192 48C165.5 48 144 69.49 144 96z" />
                        </svg>
                        Filter
                        <StateProvider
                          componentIds={['fair', 'type', 'location', 'fairSection']}
                          strict={false}
                          render={({ searchState }) => {
                            const countFair = !fair ? _.size(searchState.fair.value) : 0;
                            const countType = _.size(searchState.type.value);
                            const countLocation = _.size(searchState.location.value);
                            const countFairSection = _.size(searchState.fairSection.value);
                            const result = countFair + countType
                              + countLocation + countFairSection;
                            return result > 0
                              ? (<span className="counter-filters">{result}</span>)
                              : null;
                          }}
                        />
                      </button>
                      <div className="select-filter select-sort flex-grow-1 ms-lg-auto order-lg-2">
                        <select onChange={(e) => setSort(sortOptions[e.target.value])} data-jcf='{"wrapNative": false, "wrapNativeOnMobile": false}'>
                          {sortOptions.map((opt, index) => (
                            <option key={opt.label} value={index}>
                              {opt.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="filters-content-drop">
                  <button type="button" className="drop-heading filters-main-opener w-100">
                    <span className="title">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                        <path d="M0 416C0 407.2 7.164 400 16 400H81.6C89.01 363.5 121.3 336 160 336C198.7 336 230.1 363.5 238.4 400H496C504.8 400 512 407.2 512 416C512 424.8 504.8 432 496 432H238.4C230.1 468.5 198.7 496 160 496C121.3 496 89.01 468.5 81.6 432H16C7.164 432 0 424.8 0 416V416zM208 416C208 389.5 186.5 368 160 368C133.5 368 112 389.5 112 416C112 442.5 133.5 464 160 464C186.5 464 208 442.5 208 416zM352 176C390.7 176 422.1 203.5 430.4 240H496C504.8 240 512 247.2 512 256C512 264.8 504.8 272 496 272H430.4C422.1 308.5 390.7 336 352 336C313.3 336 281 308.5 273.6 272H16C7.164 272 0 264.8 0 256C0 247.2 7.164 240 16 240H273.6C281 203.5 313.3 176 352 176zM400 256C400 229.5 378.5 208 352 208C325.5 208 304 229.5 304 256C304 282.5 325.5 304 352 304C378.5 304 400 282.5 400 256zM496 80C504.8 80 512 87.16 512 96C512 104.8 504.8 112 496 112H270.4C262.1 148.5 230.7 176 192 176C153.3 176 121 148.5 113.6 112H16C7.164 112 0 104.8 0 96C0 87.16 7.164 80 16 80H113.6C121 43.48 153.3 16 192 16C230.7 16 262.1 43.48 270.4 80H496zM144 96C144 122.5 165.5 144 192 144C218.5 144 240 122.5 240 96C240 69.49 218.5 48 192 48C165.5 48 144 69.49 144 96z" />
                      </svg>
                      <span>Filters</span>
                    </span>
                    <span className="icon-close">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
                        <path d="M315.3 411.3c-6.253 6.253-16.37 6.253-22.63 0L160 278.6l-132.7 132.7c-6.253 6.253-16.37 6.253-22.63 0c-6.253-6.253-6.253-16.37 0-22.63L137.4 256L4.69 123.3c-6.253-6.253-6.253-16.37 0-22.63c6.253-6.253 16.37-6.253 22.63 0L160 233.4l132.7-132.7c6.253-6.253 16.37-6.253 22.63 0c6.253 6.253 6.253 16.37 0 22.63L182.6 256l132.7 132.7C321.6 394.9 321.6 405.1 315.3 411.3z" />
                      </svg>
                    </span>
                  </button>
                  <div className="filters-drop-inner-holder">
                    <div className="filters-drop-inner">
                      <div className="search-filter">
                        <DataSearch
                          innerClass={{
                            input: 'form-control',
                            list: 'gallery-title__list',
                          }}
                          componentId="q"
                          dataField={[
                            'title',
                          ]}
                          iconPosition="right"
                          filterLabel="Search term"
                          placeholder="Search for exhibitors"
                          react={{ and: ['type', 'location', 'fair', 'fairSection'] }}
                          URLParams
                          // searchOperators
                          fuzziness="AUTO"
                        />
                      </div>
                      <ul className="filters-list">
                        <li>
                          {type ? (
                            <ReactiveComponent
                              componentId="type"
                              customQuery={() => ({
                                query: {
                                  bool: {
                                    must: [
                                      {
                                        match: {
                                          'type.keyword': type,
                                        },
                                      },
                                    ],
                                  },
                                },
                              })}
                            />
                          ) : (
                            <MultiList
                              componentId="type"
                              dataField="type.keyword"
                              filterLabel="Exhibitor Type"
                              showCheckbox
                              react={{ and: ['q', 'location', 'fair', 'fairSection'] }}
                              URLParams
                              showSearch={false}
                              size={100}
                              aggregationSize={100}
                              sortBy="desc"
                            >
                              {
                                ({
                                  data,
                                  value,
                                  handleChange,
                                }) => (
                                  <CheckboxList
                                    id="type"
                                    title="Exhibitor Type"
                                    size={10}
                                    data={data}
                                    handleChange={handleChange}
                                    value={value}
                                  />
                                )
                              }
                            </MultiList>
                          )}
                        </li>
                        <li>
                          {fair ? (
                            <ReactiveComponent
                              componentId="fair"
                              customQuery={() => ({
                                query: {
                                  bool: {
                                    must: [
                                      {
                                        match: {
                                          'participations.fair.title.keyword': fair,
                                        },
                                      },
                                    ],
                                  },
                                },
                              })}
                            />
                          ) : (
                            <MultiList
                              componentId="fair"
                              dataField="participations.fair.title.keyword"
                              filterLabel="Fairs"
                              showCheckbox
                              react={{ and: ['q', 'type', 'location', 'fairSection'] }}
                              URLParams
                              showSearch={false}
                            >
                              {
                                ({
                                  data,
                                  value,
                                  handleChange,
                                }) => (
                                  <CheckboxList
                                    id="fair"
                                    title="Fairs"
                                    size={5}
                                    data={data}
                                    handleChange={handleChange}
                                    value={value}
                                  />
                                )
                              }
                            </MultiList>
                          )}
                        </li>
                        <li>
                          <MultiList
                            componentId="location"
                            dataField="locations.country.keyword"
                            filterLabel="Locations"
                            showCheckbox
                            react={{ and: ['q', 'type', 'fair', 'fairSection'] }}
                            URLParams
                            showSearch={false}
                            size={20}
                            aggregationSize={20}
                          >
                            {
                              ({
                                data,
                                value,
                                handleChange,
                              }) => (
                                <CheckboxList
                                  id="location"
                                  title="Locations"
                                  size={20}
                                  data={data}
                                  handleChange={handleChange}
                                  value={value}
                                />
                              )
                            }
                          </MultiList>
                        </li>
                        <li>
                          <MultiList
                            componentId="fairSection"
                            dataField="fairSection.keyword"
                            filterLabel="Fair sections"
                            showCheckbox
                            react={{ and: ['q', 'type', 'fair'] }}
                            URLParams
                            showSearch={false}
                            size={20}
                            aggregationSize={20}
                          >
                            {
                              ({
                                data,
                                value,
                                handleChange,
                              }) => (
                                <CheckboxList
                                  id="fairSection"
                                  title="Fair Sections"
                                  size={20}
                                  data={data}
                                  handleChange={handleChange}
                                  value={value}
                                />
                              )
                            }
                          </MultiList>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="btn-results-holder ff-apercu">
                    <button className="btn btn-dark btn-dark-force btn-results filters-main-opener" type="button">
                      Show results
                      <StateProvider
                        componentIds="page"
                        strict={false}
                        render={({ searchState }) => {
                          const { hits } = searchState.page;
                          if (!hits) {
                            return null;
                          }

                          const { total } = hits;
                          return ` (${total})`;
                        }}
                      />
                    </button>
                  </div>
                </div>
              </fieldset>
            </div>
            <hr className="d-lg-none" />
            <StateProvider
              strict={false}
              render={({ searchState }) => {
                const pageSize = 12;

                return (
                  <ReactiveList
                    componentId="page"
                    innerClass={{ pagination: 'pagination reactive-pagination reactive-pagination--exhibitor-catalog' }}
                    dataField="id"
                    size={pageSize}
                    showResultStats={false}
                    URLParams
                    react={{ and: ['q', 'type', 'location', 'fair', 'fairSection'] }}
                    defaultQuery={() => ({ sort: sort.sortBy })}
                    scrollOnChange={false}
                    onData={() => {
                      window.initStickyScrollBlock();
                      window.initPinning('#filters-wrap--exhibitors');
                    }}
                    render={({ data }) => (
                      <div className="ajax-load-content row">
                        <div className="col-12">
                          <div className="items-holder row gy-3 gy-md-6">
                            {data.map((item) => {
                              let locationIndex = 0;
                              const selectedLocationCity = searchState.location?.value;
                              if (selectedLocationCity && item.locations) {
                                Object.keys(item.locations).forEach((key) => {
                                  if (item.locations[key].city === selectedLocationCity) {
                                    locationIndex = key;
                                  }
                                });
                              }
                              const image = _.get(
                                item,
                                `locations[${locationIndex}].image.transforms.catalog.url`,
                                _.get(
                                  item,
                                  `locations[${locationIndex}].image.url`,
                                  '/dist/images/exhibitor-fallback-image.jpg',
                                ),
                              );
                              const imageWidth = _.get(
                                item,
                                `locations[${locationIndex}].image.transforms.catalog.width`,
                              );
                              const imageHeight = _.get(
                                item,
                                `locations[${locationIndex}].image.transforms.catalog.height`,
                              );
                              const city = _.get(item, `locations[${locationIndex}].city`, null);

                              let standNumber = null;
                              if (fair) {
                                const participation = (item.participations || [])
                                  .find((p) => p.fair?.title === fair);
                                if (participation) {
                                  standNumber = participation.standNumber || null;
                                }
                              }

                              return (
                                /* eslint-disable-next-line no-underscore-dangle */
                                <div key={item._id} className="col-md-6 col-xl-4">
                                  <a className={`item${standNumber ? ' item-stand-number' : ''}`} href={item.url}>
                                    {image && (
                                      <picture>
                                        <img
                                          src={image}
                                          alt={city || ''}
                                          width={imageWidth}
                                          height={imageHeight}
                                        />
                                      </picture>
                                    )}
                                    <div className="item-inner item-inner-secondary">
                                      <h3 className="mb-0 h2">{item.title}</h3>
                                      <div className="hover-info">
                                        <hr className="my-4" />
                                        <div className="d-flex justify-content-between">
                                          <span className="me-4">{item.galleryTagline}</span>
                                          <button type="button" className="btn btn-sm btn-outline-light flex-shrink-0 h-100">More info</button>
                                        </div>
                                      </div>
                                    </div>
                                    {(standNumber) && (
                                      <div className="item-inner item-inner-secondary stand-number fw-medium">
                                        {`Stand ${standNumber}`}
                                      </div>
                                    )}
                                  </a>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                    )}
                  />
                );
              }}
            />
          </div>
        </div>
      </div>
    </ReactiveBase>
  );
}

ExhibitorsCatalog.propTypes = {
  url: PropTypes.string.isRequired,
  credentials: PropTypes.string.isRequired,
  app: PropTypes.string.isRequired,
  fair: PropTypes.string,
  defaultValue: PropTypes.string,
  type: PropTypes.string,
};

ExhibitorsCatalog.defaultProps = {
  fair: '',
  defaultValue: '',
  type: '',
};

export { ExhibitorsCatalog };
